<template lang="pug">
.image-gallery(
  @mouseover="mouseover"
  @mouseout="mouseout"
)
  .image-gallery-images
    .image-gallery-image(
      v-for="(image, $index) in images"
      :key="image.id"
      :class="{ 'is-active': active === $index }"
    )
      cl-img(
        :cl-id="image.cl_id"
        :transform="transform"
      )
  .image-gallery-controls
    a(@click="prev")
      b-icon(icon="angle-left" pack="fas")
    a(@click="next")
      b-icon(icon="angle-right" pack="fas")
</template>

<script>
export default {
  name: 'image-gallery',
  computed: {
    images() {
      return this.value;
    },
  },
  destroyed() {
    this.stop();
  },
  data() {
    return {
      auto: null,
      active: 0,
    };
  },
  methods: {
    mouseover() {
      this.stop();
    },
    mouseout() {
      if (this.active) {
        this.start();
      }
    },
    next() {
      if (this.active === this.images.length - 1) {
        this.active = 0;
      } else {
        this.active += 1;
      }
    },
    prev() {
      if (this.active === 0) {
        this.active = this.images.length - 1;
      } else {
        this.active -= 1;
      }
    },
    start() {
      this.auto = window.setInterval(() => {
        this.next();
      }, this.duration);
    },
    stop() {
      clearInterval(this.auto);
    },
  },
  mounted() {
    if (this.autoplay) {
      this.start();
    }
  },
  props: {
    autoplay: {
      type: Boolean,
      default: true,
    },
    duration: {
      type: Number,
      default: 6500,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    transform: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
@keyframes fadeImage {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.image-gallery {
  position: relative;
  width: 100%;
  overflow: hidden;
  .image-gallery-images {
    .image-gallery-image {
      display: none;
      &.is-active {
        display: block;
        animation: fadeImage 0.8s;
      }
      img {
        width: auto !important;
      }
    }
  }
  .image-gallery-controls {
    position: absolute;
    bottom: 2px;
    left: 12px;
    a {
      background-color: rgba(0,0,0,0.5);
      transition: 0.35s background-color ease-in-out;
      color: $white;
      padding: 0.5rem 0.25rem;
      &:hover {
        background-color: rgba(0,0,0,0.65);
      }
    }
  }
}
</style>
